<dx-form labelMode="floating" labelLocation="top">
  <dxi-item [colSpan]="6">
    <dxo-label [template]="head"></dxo-label>
    <dx-drop-down-box 
      [(value)]="value" 
      valueExpr="id" 
      [displayExpr]="displayexpr || 'nameAr'"
      placeholder="{{'Selectavalue'|translate}}" 
      [showClearButton]="true" 
      [dataSource]="m"
      contentTemplate="content">
      
      <dx-validator>
        <dxi-validation-rule type="required" message="{{'errors.required'|translate}}"></dxi-validation-rule>
      </dx-validator>
      
      <div *dxTemplate="let data of 'content'">
        <dx-data-grid 
          [dataSource]="m" 
          [columns]="coulmn" 
          keyExpr="id" 
          [selection]="{ mode: selectionmode || 'multiple' }" 
          [hoverStateEnabled]="true"
          [paging]="{ enabled: true, pageSize: 10 }" 
          [filterRow]="{ visible: true }" 
          [scrolling]="{ mode: 'virtual' }"
          [height]="345" 
          [(selectedRowKeys)]="value"
          (onSelectionChanged)="onSelectionChanged($event.selectedRowKeys)">
        </dx-data-grid>
      </div>
    </dx-drop-down-box>
  </dxi-item>
</dx-form>